import React from "react";

/**
 * The heading every card on this page wears: a coloured chip, the title, and
 * whatever badges belong on the right of it.
 *
 * The chip carries a step number for the four cards that are a sequence -
 * add the code, preview it, check it took, recrawl - and an icon for the
 * settings cards, which are not steps and have no order to be in. Written
 * once here so the numbers can't drift out of sequence card by card.
 *
 * @param step   the step number, for the four numbered cards
 * @param icon   a lucide component, for the rest
 * @param tone   which colour the chip is: blue, purple, green, amber, red
 * @param aside  badges for the right-hand end of the row
 */
export default function CardHeading({
  step,
  icon: Icon,
  tone = "blue",
  title,
  subtitle,
  aside,
}) {
  return (
    <>
      <div className="ist-head">
        <span className={`ist-head__chip ist-head__chip--${tone}`}>
          {step ?? (Icon ? <Icon size={17} strokeWidth={2.1} /> : null)}
        </span>

        <h2 className="ist-head__title">{title}</h2>

        {aside && <span className="ist-head__aside">{aside}</span>}
      </div>

      {subtitle && <p className="ist-card-subtitle">{subtitle}</p>}
    </>
  );
}
